import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsDate, IsNumber, IsOptional, IsString } from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

@Index('promo__registry__code', ['code'], {
  unique: true,
})
export class PromoRegistry extends BasicEntity {
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: false, default: '' })
  code: string;

  /** 0 - unlimited **/
  @Column({ type: 'int', nullable: false, default: 0 })
  @IsNumber({}, { groups: ['error'] })
  maxActivations: number;

  @Column({ type: 'int', nullable: false, default: 0 })
  @IsNumber({}, { groups: ['error'] })
  currentActivations: number;

  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  @IsDate({ groups: ['error'] })
  startedAt: Date | null;

  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  @IsDate({ groups: ['error'] })
  expiredAt: Date | null;

  @ApiProperty()
  @Column({ type: 'int', nullable: false, default: 0 })
  @IsNumber({}, { groups: ['error'] })
  coins: number;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: true })
  userId?: number | null;
}
